import { render, staticRenderFns } from "./Salesman.vue?vue&type=template&id=82a216e8"
import script from "./Salesman.vue?vue&type=script&lang=js"
export * from "./Salesman.vue?vue&type=script&lang=js"
import style0 from "./Salesman.vue?vue&type=style&index=0&id=82a216e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports